module.exports = __webpack_public_path__ + "static/media/13.6a49eac3.jpg";